/**
 * return k-text-color-[name]
 * @param name
 */
export default (name?: string) => {
  if(!name) {
    return ''
  }
  return ['k-text-color', name].join('-')
}
